import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs-compat";

@Component({
    selector: "ngx-add-crowdsale",
    template: `<ngx-one-column-layout>
        <router-outlet></router-outlet>
    </ngx-one-column-layout>`,
    styleUrls: ["./add-crowdsale.component.scss"],
})
export class AddCrowdsaleLayoutComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
